import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { IN2kState } from './types';
import { N2KFluidLevelEventType, IN2KFluidLevelEvent, N2KWindEventReference, IN2KWindEvent,
    IN2KWaterDepthEvent, IN2KSpeedEvent, N2KSpeedEventReference, IN2KTemperatureEvent,
    N2KTemperatureEventSource, IN2KGnssEvent, N2KHeadingEventReference, IN2KHeadingEvent,
    IN2KRudderEvent, N2KGnssEventType, IN2KOutsideEnvironmentalEvent } from '@/common/apis/DeviceApi';

export const getters: GetterTree<IN2kState, RootState> = {
    fluid(state): (deviceNumber: string, type: N2KFluidLevelEventType) => IN2KFluidLevelEvent | null {
        return (deviceNumber: string, type: N2KFluidLevelEventType): IN2KFluidLevelEvent | null => {
            const device = state.devices[deviceNumber];
            if (!device || !device.fluid[type]) {
                return null;
            }
            return device.fluid[type] || null;
        };
    },
    windAll(state): (deviceNumber: string) => {[key in N2KWindEventReference]?: IN2KWindEvent} | null {
        return (deviceNumber: string): {[key in N2KWindEventReference]?: IN2KWindEvent} | null => {
            const device = state.devices[deviceNumber];
            if (!device || !device.wind) {
                return null;
            }
            return device.wind;
        };
    },
    temperatures(state): (deviceNumber: string) => {[key in N2KTemperatureEventSource]?: IN2KTemperatureEvent} | null {
        return (deviceNumber: string): {[key in N2KTemperatureEventSource]?: IN2KTemperatureEvent} | null => {
            const device = state.devices[deviceNumber];
            if (!device || !device.temperature) {
                return null;
            }
            return device.temperature;
        };
    },
    wind(state): (deviceNumber: string, reference: N2KWindEventReference) => IN2KWindEvent | null {
        return (deviceNumber: string, reference: N2KWindEventReference): IN2KWindEvent | null => {
            const device = state.devices[deviceNumber];
            if (!device || !device.wind[reference]) {
                return null;
            }
            return device.wind[reference] || null;
        };
    },
    waterDepth(state): (deviceNumber: string) => IN2KWaterDepthEvent | null {
        return (deviceNumber: string): IN2KWaterDepthEvent | null => {
            const device = state.devices[deviceNumber];
            if (device && device.waterDepth) {
                return device.waterDepth || null;
            }
            return null;
        };
    },
    heading(state): (deviceNumber: string) => {[key in N2KHeadingEventReference]?: IN2KHeadingEvent} | null {
        return (deviceNumber: string): {[key in N2KHeadingEventReference]?: IN2KHeadingEvent} | null => {
            const device = state.devices[deviceNumber];
            if (device && device.heading) {
                return device.heading || null;
            }
            return null;
        };
    },
    speed(state): (deviceNumber: string) => {[key in N2KSpeedEventReference]?: IN2KSpeedEvent} | null {
        return (deviceNumber: string): {[key in N2KSpeedEventReference]?: IN2KSpeedEvent} | null => {
            const device = state.devices[deviceNumber];
            if (device && device.speed) {
                return device.speed || null;
            }
            return null;
        };
    },
    gnss(state): (deviceNumber: string) => {[type in N2KGnssEventType]?: IN2KGnssEvent} | null {
        return (deviceNumber: string): {[type in N2KGnssEventType]?: IN2KGnssEvent} | null => {
            const device = state.devices[deviceNumber];
            if (device && device.gnss) {
                return device.gnss || null;
            }
            return {};
        };
    },
    rudder(state): (deviceNumber: string) => IN2KRudderEvent | null {
        return (deviceNumber: string): IN2KRudderEvent | null => {
            const device = state.devices[deviceNumber];
            if (device && device.rudder) {
                return device.rudder || null;
            }
            return null;
        };
    },
    outsideEnvironmental(state): (deviceNumber: string) => IN2KOutsideEnvironmentalEvent | null {
        return (deviceNumber: string): IN2KOutsideEnvironmentalEvent | null => {
            const device = state.devices[deviceNumber];
            if (device && device.outsideEnvironmental) {
                return device.outsideEnvironmental || null;
            }
            return null;
        };
    },
};
